import { useTracking } from 'react-tracking';

import { useMount } from '@simplywallst/ui-core';

import { PortfolioIllustration } from '../PortfolioIllustration';

export const ErrorState = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    modifier: 'errorState',
  });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  return (
    <Track>
      <section className="grid items-center justify-items-center">
        <div className="grid auto-rows-auto justify-items-center gap-4">
          <PortfolioIllustration />
          <div>
            <h3 className="mb-x0_5 text-center text-sm font-strong text-solid">
              Something went wrong!
            </h3>
            <p className="text-center text-xs text-softer">
              We're sorry, but an error occurred. Please try again later.
            </p>
          </div>
        </div>
      </section>
    </Track>
  );
};
